const filter = document.getElementById('filter') || false;

if (filter) {
    filter.addEventListener('change', evt => {
        if (evt.target.tagName !== 'SELECT') {
            utag && utag.link({'wt_link_id' : document.querySelector(`[for="${evt.target.id}"] scale-tag`).dataset.tealiumRel});
        } else {
            utag && utag.link({'wt_link_id' : evt.target.closest('scale-dropdown').dataset.tealiumRel});
        }

        const parser = new URL(window.location);
        parser.hash = '#filter';
        window.history.pushState({}, '', parser);

        setTimeout(() => {
            filter.submit();
        }, 100);
    });
}

document.querySelectorAll('scale-pagination').forEach(pagination => {
    pagination.addEventListener('scale-pagination', evt => {
        const parser = new URL(window.location);
        parser.searchParams.set(evt.target.dataset.name, evt.detail.startElement);
        parser.hash = '#filter';
        window.location = parser.href;
    })
});
